module.exports = __webpack_public_path__ + "static/img/somewhat-satisfied-01.7b53907.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/somewhat-satisfied-01.jpg
// module id = 292
// module chunks = 1